import { Component, ViewEncapsulation, effect, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DynamicComponent, Register } from '@xanadu/core';

interface ExpandModel {
    child: any;
    meta: {
        title?: string;
        description?: string;
        editable?: boolean;
    };
}

@Component({
    selector: 'app-expand',
    templateUrl: './expand.component.html',
    styleUrls: ['./expand.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('expand')
export class ExpandComponent extends DynamicComponent {
    readonly model = input.required<ExpandModel>();
    readonly tagChange = output<{ tag: string; data: ExpandModel }>();

    readonly titleControl = new FormControl('', {
        nonNullable: true
    });

    disable = false;

    constructor() {
        super();

        effect(() => {
            const model = this.model();

            this.titleControl.setValue(model.meta.title ?? '', {
                emitEvent: false
            });
        });
    }

    onFocus(): void {
        this.disable = true;
    }

    onChange(event: Event): void {
        const inputElement = event.target as HTMLInputElement;

        this.disable = false;

        this.tagChange.emit({
            tag: inputElement.value,
            data: this.model()
        });
    }
}
